import { writable, get } from 'svelte/store';
import * as util from '../js/util.js';

function createMyStore() {
    const { subscribe, set, update } = writable(
        {
            loggedInUser: { roles: [] },
            users: []
            // roles: []
        }
    );
    return {
        subscribe,
        getUsers: async () => {
            const json = await util.fetchJson('api/User/getusers');
            update(n => { return Object.assign(n, { users: json }) });
        },
        save: async (theUser) => {
            var ret = await util.fetchJsonWithMethod('POST', 'api/User/saveUser', theUser);
            var allUsers = await usersStore.getUsers();
            return ret;
        },
        // getRoleNames: async () => {
        //     var roles = await util.fetchJson('api/Users/getrolenames');
        //     update(n => { return Object.assign(n, { roles: roles }) });

        // },
        getLoggedInUser: async () => {
            var user = await util.fetchJson('api/auth/getloggedinuser', 1);
            update(n => { return Object.assign(n, { loggedInUser: user.data }) });
            return user;


        },
        login: async(userName, password) =>{
            var loginDetails = { userName: userName, password: password };
            var json =  await util.fetchJsonWithMethod('POST', 'api/auth/login', loginDetails)
            update(n => { return Object.assign(n, { loggedInUser: json.data }) });
            return json;
        },
        logout: async()=>{
            return await util.fetchJson('api/auth/logout');
        }

    };
}
export const usersStore = createMyStore(); 